import Loadable from 'react-loadable';
import Loading from 'components/Loading';
import {AppSettings} from '../constants';

const ManageSubcontractors = Loadable({
  loader: () => import('./Containers/manage-subcontractors'),
  loading: Loading
});

const SearchCompany = Loadable({
  loader: () => import('./Containers/search-company-subcontractor'),
  loading: Loading
});

const InviteSubcontractor = Loadable({
  loader: () => import('./Containers/invite-subcontractor'),
  loading: Loading
});

const ManageSubAssignments = Loadable({
  loader: () => import('./Containers/manage-sub-assignments'),
  loading: Loading
});

const AddContractor = Loadable({
  loader: () => import('./Containers/add-subcontractor'),
  loading: Loading
});

const SubcontractorAlreadyExists = Loadable({
  loader: () => import('./Containers/subcontractor-already-exists'),
  loading: Loading
});

const BulkMailSystem = Loadable({
  loader: () => import('BulkMail/bulk-mail-system'),
  loading: Loading
});

let routes = [
  {
    path: '/subcontractors',
    component: ManageSubcontractors,
    private: true,
    menu: {
      name: 'Subcontractors',
      order: 6,
      group: 'Subcontractor',
      icons: 'icon-subcontractors-ic',
      className: 'menu-divide'
    }
  },
  {
    path: '/subcontractors/search-company-name',
    component: SearchCompany,
    private: true
  },
  {
    path: '/subcontractors/invite',
    component: InviteSubcontractor,
    private: true
  },
  {
    path: '/subcontractors/add/:companyName',
    component: AddContractor,
    private: true
  },
  {
    path: '/subcontractors/sub-already-exists',
    component: SubcontractorAlreadyExists,
    private: true
  },
  {
    path: '/subcontractor-assignments',
    component: ManageSubAssignments,
    private: true,
    portal: ['Builder'],
    menu: {
      name: 'Subcontractor assignments',
      order: 7,
      icons: 'icon-subcontractors-assignments-ic',
      group: 'Subcontractor',
      condition: () => {
        return AppSettings.CURRENT_SITE_URI !== AppSettings.SITE_ONE_SERVICE_URI;
      }
    }
  }
];

if (AppSettings.clientTypeValue === 'System') {
  routes.push(
    {
      path: '/bulk-mail',
      component: BulkMailSystem,
      private: true,
      menu: {
        name: 'Bulk mail',
        order: 6,
        iconClass: 'pe-7s-mail'
      }
    }
  );
}

export default routes;



// WEBPACK FOOTER //
// ./src/Subcontractors/routes.js